module.exports = __webpack_public_path__ + "static/media/logoCSS3.120e1a92.svg";